import FileProviderView from './FileProviderView';
import LocalComputerFilePicker from './LocalComputerFilePicker';
import { observer } from 'mobx-react';
import { getIconForFileProvider as getLocalComputerIconCSS } from 'owa-fileprovider-icon';
import { FileSelectionFilter } from 'owa-fileprovider-store';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';

const styles = require('./LocalComputerFileProviderView.scss');

export interface LocalComputerFileProviderViewProps {
    onFilesSelected: (files: File[], fileSelectionFilter: FileSelectionFilter) => void;
    fileSelectionFilter: FileSelectionFilter;
    onLocalComputerClicked: () => void;
}

@observer
export default class LocalComputerFileProviderView extends React.Component<
    LocalComputerFileProviderViewProps,
    {}
> {
    private localComputerFilePicker: LocalComputerFilePicker;

    render() {
        return (
            <div>
                <FileProviderView
                    name={strings.ComputerFileProviderDisplayName}
                    icon={getLocalComputerIconCSS(ControlIcons.System, styles.computerImage)}
                    onClick={this.onLocalComputerFileProviderClicked}
                    ariaLabel={format(
                        strings.FileProviderAriaText,
                        strings.ComputerFileProviderDisplayName
                    )}
                />

                <LocalComputerFilePicker
                    ref={ref => (this.localComputerFilePicker = ref)}
                    onFilesSelected={files =>
                        this.props.onFilesSelected(files, this.props.fileSelectionFilter)
                    }
                    fileSelectionFilter={this.props.fileSelectionFilter}
                />
            </div>
        );
    }

    private onLocalComputerFileProviderClicked = () => {
        this.props.onLocalComputerClicked();
        this.localComputerFilePicker.click();
    };
}
